<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Cotizar servicio</span
            >
            <button
                mat-icon-button
                aria-label="Close dialog"
                (click)="dialogRef.close()"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <div>
            <mat-list>
                <mat-list-item>
                    <h3 matLine>Servicio</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.descripcion }} -
                            {{ data.atributos.join(", ") }}
                        </span>
                    </p>
                </mat-list-item>
            </mat-list>
            <mat-list>
                <mat-list-item>
                    <h3 matLine>Cliente</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.sucursal.cliente.nombre }} - ({{
                                data.sucursal.cliente.rut
                            }})
                        </span>
                    </p>
                </mat-list-item>
            </mat-list>
            <mat-list>
                <mat-list-item>
                    <h3 matLine>Sucursal</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.sucursal.nombre }} -
                            {{ data.sucursal.direccion }},
                            {{ data.sucursal.comuna.nombre }}
                        </span>
                    </p>
                </mat-list-item>
            </mat-list>
            <mat-list>
                <mat-list-item>
                    <h3 matLine>Condición</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.condicion.descripcion }}
                        </span>
                    </p>
                </mat-list-item>
            </mat-list>
            <mat-list *ngIf="data.cantidad">
                <mat-list-item>
                    <h3 matLine>Cantidad</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.cantidad }}
                            {{ data.unidadMedida.descripcion }}</span
                        >
                    </p>
                </mat-list-item>
            </mat-list>
            <mat-list *ngIf="data.tiempo">
                <mat-list-item>
                    <h3 matLine>Tiempo</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.tiempo }}
                            {{ data.unidadTiempo.descripcion }}</span
                        >
                    </p>
                </mat-list-item>
            </mat-list>
            <mat-list *ngIf="data.grupoServicio.id != 0">
                <mat-list-item>
                    <h3 matLine>Valor</h3>
                    <p matLine>
                        <span class="secondary-text">
                            UF {{ data.valorMinimo }} - UF
                            {{ data.valorMaximo }}
                        </span>
                        <br />
                        <span class="primary p-4">
                            {{
                                data.valorMinimoCLP
                                    | currency: "CLP":"symbol-narrow"
                            }}
                            -
                            {{
                                data.valorMaximoCLP
                                    | currency: "CLP":"symbol-narrow"
                            }}</span
                        >
                    </p>
                </mat-list-item>
            </mat-list>
            <mat-list>
                <mat-list-item>
                    <h3 matLine>Observaciones</h3>
                    <p matLine>
                        <span class="secondary-text">
                            {{ data.descripcionSolicitud }}
                        </span>
                    </p>
                </mat-list-item>
            </mat-list>

            <form
                class="form p-4"
                [formGroup]="formCotizarServicio"
                autocomplete="off"
            >
                <mat-form-field class="full-width">
                    <mat-label>Observaciones </mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="descripcionTrabajo"
                        required
                    />
                    <mat-hint
                        >{{ descripcionTrabajo.value?.length }} /
                        {{ largoMaximo }}</mat-hint
                    >

                    <mat-error *ngIf="descripcionTrabajo.hasError('required')">
                        Debe ingresar una observación
                    </mat-error>
                    <mat-error *ngIf="descripcionTrabajo.hasError('minlength')">
                        Debe ingresar al menos
                        {{
                            descripcionTrabajo.getError("minlength")
                                .requiredLength
                        }}
                        caracteres
                    </mat-error>
                    <mat-error *ngIf="descripcionTrabajo.hasError('maxlength')">
                        Máximo
                        {{
                            descripcionTrabajo.getError("maxlength")
                                .requiredLength
                        }}
                        caracteres
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Tiempo del trabajo </mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="tiempoTrabajo"
                        min="0"
                        required
                    />
                    <span matSuffix> días </span>

                    <mat-error *ngIf="tiempoTrabajo.hasError('required')">
                        Debe ingresar el tiempo de duración del trabajo
                    </mat-error>
                    <mat-error *ngIf="tiempoTrabajo.hasError('max')">
                        El tiempo de trabajo no puede ser superior a 50.000.000
                    </mat-error>
                    <mat-error *ngIf="tiempoTrabajo.hasError('min')">
                        El tiempo de trabajo no puede ser menor a 0
                    </mat-error>
                    <mat-error *ngIf="tiempoTrabajo.hasError('pattern')">
                        El tiempo de trabajo debe ser numérico
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="full-width">
                    <mat-label>Valor servicio</mat-label>
                    <input
                        matInput
                        type="text"
                        formControlName="valor"
                        placeholder="Valor del servicio en UF"
                        min="0"
                        required
                    />
                    <span matPrefix>UF&nbsp;</span>

                    <mat-error *ngIf="valor.hasError('required')">
                        Debe ingresar el valor de la cotización
                    </mat-error>
                    <mat-error *ngIf="valor.hasError('max')">
                        El valor del servicio no puede ser superior a 50.000.000
                    </mat-error>
                    <mat-error *ngIf="valor.hasError('min')">
                        El valor del servicio no puede ser menor a 0
                    </mat-error>
                    <mat-error *ngIf="valor.hasError('pattern')">
                        El valor del servicio debe ser numérico
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cerrar</button>
        <button
            mat-raised-button
            color="accent"
            [mat-dialog-close]="formCotizarServicio.value"
            [disabled]="!formCotizarServicio.valid"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
